import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import UserWorkflowInfo from "./UserWorkflowInfo";
import { IUserTaskCount } from "../../../models/Task";
import { useTranslation } from "react-i18next";

interface DataTableProps {
  data?: IUserTaskCount[];
}

export default function DataTable({ data = [] }: DataTableProps) {
  const { t } = useTranslation();

  return (
    <div
      className="hidden-scroll"
      style={{
        height: "484px",
        overflow: "auto",
        position: "relative"
      }}
    >
      <Table
        sx={{
          width: "100%"
        }}
      >
        <TableHead
          sx={{
            position: "sticky",
            top: 0,
            backgroundColor: "#FAFAFA",
            zIndex: 10
          }}
        >
          <TableRow>
            <TableCell
              sx={{
                padding: "14px 0",
                fontWeight: "500",
                color: "#7B7B7B",
                fontSize: '0.7rem'
              }}
            >
              {t("Summary.Table.Performer")}
            </TableCell>
            <TableCell
              sx={{
                padding: "14px 0",
                fontWeight: "500",
                width: "20%",
                textAlign: "right",
                color: "#7B7B7B",
                fontSize: '0.7rem'
              }}
            >
              {t("Summary.Table.InProgress")}
            </TableCell>
            <TableCell
              sx={{
                padding: "14px 0",
                fontWeight: "500",
                width: "20%",
                textAlign: "right",
                color: "#7B7B7B",
                fontSize: '0.7rem'
              }}
            >
              {t("Summary.Table.Failed")}
            </TableCell>
            <TableCell
              sx={{
                padding: "14px 0",
                fontWeight: "500",
                width: "20%",
                textAlign: "right",
                color: "#7B7B7B",
                fontSize: '0.7rem'
              }}
            >
              {t("Summary.Table.Completed")}
            </TableCell>
            <TableCell
              sx={{
                padding: "14px 0",
                fontWeight: "500",
                width: "20%",
                textAlign: "right",
                color: "#7B7B7B",
                fontSize: '0.7rem'
              }}
            >
              {t("Summary.Table.Cancelled")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(item => (
            <TableRow key={item.userId}>
              <TableCell sx={{ padding: "0" }}>
                <div
                  className="w-full"
                  style={{
                    backgroundColor: "#FAFAFA",
                    paddingBottom: "0",
                    maxHeight: "300px",
                    borderRadius: "10px"
                  }}
                >
                  <div className="hidden-scroll" style={{ maxHeight: "238px" }}>
                    <UserWorkflowInfo
                      name={item.userFullName}
                      avatar={item.avatar}
                      total_task={item.totalTasks}
                    />
                  </div>
                </div>
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "500",
                  padding: "0",
                  paddingBottom: "8px",
                  textAlign: "right",
                  color: "#021C5E"
                }}
              >
                {item.inProgressTasks}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "500",
                  padding: "0",
                  paddingBottom: "8px",
                  textAlign: "right",
                  color: "#021C5E"
                }}
              >
                {item.failedTasks}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "500",
                  padding: "0",
                  paddingBottom: "8px",
                  textAlign: "right",
                  color: "#021C5E"
                }}
              >
                {item.completedTasks}
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "500",
                  padding: "0",
                  paddingBottom: "8px",
                  textAlign: "right",
                  color: "#021C5E"
                }}
              >
                {item.cancelledTasks}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
